import fetchData from '@/utils/fetchData'
import { defineStore } from 'pinia'

export const useCodelistStore = defineStore({
  id: 'codelist',
  state: () => ({
    codelist: {},
    indicators: [],
    indicatorsTYS: []
  }),
  actions: {
    async fetchCodelist (locale) {
      const codelists = await fetchData(`${import.meta.env.VITE_API_URL}/api/${import.meta.env.VITE_API_VERSION}/codelists?lang=${locale}`)
      this.codelist = codelists.codelists
    },
    async fetchIndicators () {
      const indicators = await fetchData(`${import.meta.env.VITE_API_URL}/api/results/indicators.json`)
      this.indicators = indicators.sort((a, b) => a.indicator_name.trim() > b.indicator_name.trim() ? 1 : -1)
    },
    async fetchTYSIndicators () {
      const indicatorsTYS = await fetchData(`${import.meta.env.VITE_API_URL}/api/tys/all.json`)
      this.indicatorsTYS = indicatorsTYS.sort((a, b) => a.name_en.trim() > b.name_en.trim() ? 1 : -1)
    }
  },
  persist: true
})
